import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { AppConfig } from '../models/AppConfig.model';

export const ConfigStore = signalStore(
  { providedIn: 'root' },
  withState({
    loaded: false,
    config: null as AppConfig | null,
  }),
  withMethods((store) => ({
    setConfig: (config: AppConfig) =>
      patchState(store, { config, loaded: true }),
  }))
);
